<div fxLayout="row">
    <p fxFlex="70">{{ "empty." + key | translate }}</p>
<div>
